

const Navbar = () => {
    return (
        <div>
            <nav className="navbar bg-dark">
                <div className="centrar">
                    <img src="https://cdn-icons-png.flaticon.com/512/6183/6183015.png" alt="Logo" width="30" height="30" className="d-inline-block align-text-top " />
                  <span className="navbar-brand mb-0 h1 text-center text-light">WEATHER app</span>
                </div>
            </nav>

        </div>
    );
}

export default Navbar;
